interface UserInfo {
  userId: string;
  userName: string;
  roles: string[];
  locale?: string;
}

export const useAdobeAnalytics = () => {
  function getInstance(): string {
    const location = window.location.hostname;

    if (location.includes('localhost')) {
      return 'local';
    } else if (location.includes('devl')) {
      return 'dev';
    } else if (location.includes('directmaterialsstrategymanagement')) {
      return 'prod';
    }
    return '';
  }

  const pushAdobeAnalytics = async (
    pageName: string,
    userInfo: UserInfo | null | undefined
  ) => {
    if (!userInfo || !userInfo.userName) {
      return;
    }
    const adobeDataLayer: object[] = (window as any).adobeDataLayer || [];
    const dataLayer = {
      event: 'appLoad',
      app: {
        instance: getInstance(),
        appId: 'DMSM',
        appName: 'Direct Materials Strategy Management',
        server: window.location.hostname,
        pathName: window.location.pathname,
        appVersion: ''
      },
      user: {
        userId: userInfo.userId,
        userName: userInfo.userName,
        userRoles: userInfo.roles,
        browserLanguage: userInfo.locale
      },
      page: {
        pathName: window.location.pathname,
        pageID: 'appJS',
        pageName: pageName
      }
    };
    adobeDataLayer.push(dataLayer);
    (window as any).adobeDataLayer = adobeDataLayer;
    return adobeDataLayer;
  };

  return {
    pushAdobeAnalytics
  };
};
